module.exports = __webpack_public_path__ + "static/media/iphone6-2up-dotted.8b491946.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/smartphone/iphone6/iphone6-2up-dotted.svg
// module id = 35
// module chunks = 0